import React from 'react';
import { useTranslation } from 'react-i18next';

export const PageLoading: React.FC<{ fullScreen?: boolean }> = ({ fullScreen = false }) => {
  const { t } = useTranslation();
  return (
    <div
      role="status"
      aria-busy="true"
      className={`flex items-center justify-center bg-gray-50 p-6 ${fullScreen ? 'min-h-screen' : 'min-h-[40vh]'}`}
    >
      <div className="boot-loading-inner">
        <div className="boot-loading-spinner" aria-hidden="true" />
        <p className="boot-loading-text">{t('common.loading')}</p>
      </div>
    </div>
  );
};

export const PageLoadError: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div role="alert" className="flex min-h-screen flex-col items-center justify-center gap-4 p-6 text-center">
      <p>{t('common.page_load_failed')}</p>
      <button
        type="button"
        className="rounded-xl border border-gray-300 px-5 py-3"
        onClick={() => window.location.reload()}
      >
        {t('common.reload_page')}
      </button>
    </div>
  );
};
